// extracted by mini-css-extract-plugin
export default {"mainMenu":"regularMenu_mainMenu__XGp-F","linkToHome":"regularMenu_linkToHome__HaF2H","secondLevel":"regularMenu_secondLevel__xhPE4","liTitle":"regularMenu_liTitle__Cvqga"};